module.exports = __webpack_public_path__ + "static/img/viral_15.d22c2ac9.jpg";